import classNames from "@casino/external/classNames";
import { DialogContent } from "@workspace/frontend-ui";
import type { ComponentProps, FC } from "react";
import { useEffect, useState } from "react";

type Props = ComponentProps<typeof DialogContent>;

const MobileDialogContent: FC<Props> = ({ className, children, ...props }) => {
  const [keyboardOffset, setKeyboardOffset] = useState(0);
  const [viewportHeight, setViewportHeight] = useState(0);

  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;

    const handleViewportChange = () => {
      setKeyboardOffset(
        Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop),
      );
      setViewportHeight(viewport.height);
    };

    handleViewportChange();

    viewport.addEventListener("resize", handleViewportChange);
    viewport.addEventListener("scroll", handleViewportChange);
    return () => {
      viewport.removeEventListener("resize", handleViewportChange);
      viewport.removeEventListener("scroll", handleViewportChange);
    };
  }, []);

  return (
    <DialogContent
      aria-describedby={undefined}
      showCloseButton={false}
      style={{
        ...(keyboardOffset ? { bottom: keyboardOffset } : null),
        ...(viewportHeight ? { maxHeight: viewportHeight } : null),
      }}
      className={classNames(
        "bg-background max-w-none w-full top-auto fixed rounded-xl p-0 overflow-y-scroll",
        "gap-0 transform-none translate-y-0 bottom-[env(safe-area-inset-bottom,0px)]",
        className,
      )}
      {...props}
    >
      {children}
    </DialogContent>
  );
};

export default MobileDialogContent;
